export const RQ_GET_RXBER_REPORTS_API = {
  url:'reports/web/effort/rxber_report/<%= divisionId %>/<%= fromDateStr %>/<%= toDateStr %>?entityTagId=<%= entityTagId %>',
  method:'GET',
  auth:true,
};
